var r = /* @__PURE__ */ ((e) => (e.LISTING = "Listing", e.UNLISTING = "UnListing", e))(r || {}), p = /* @__PURE__ */ ((e) => (e.Opened = "Opened", e.Matched = "Matched", e.Expired = "Expired", e.OffererCancel = "OffererCancel", e))(p || {});
export {
  r as ListingStatus,
  p as RoninOrderStatus
};
//# sourceMappingURL=listingInfo.js.map
